module.exports = __webpack_public_path__ + "static/media/test1.dbca9ed9.jpeg";